import React from 'react';
import { InsightsSummary } from 'types';

type Props = {
    summary: InsightsSummary;
    isLatest: boolean;
    onClick: () => void;
};

function formatDate(iso: string): string {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export default function SummaryHistoryCard({ summary, isLatest, onClick }: Props) {
    return (
        <button className='summary-history-card' onClick={onClick}>
            <span className='summary-history-card__date'>{formatDate(summary.generatedAt)}</span>
            {isLatest && <span className='summary-history-card__badge'>Latest</span>}
            <span className='summary-history-card__arrow' aria-hidden='true'>›</span>
        </button>
    );
}
